<template>
  <div>
    <div class="driver-info" v-if="driverInformation">
      <h5>{{ _T('Drivers Information') }}</h5>
      <ul class="driver-plate">
        <li v-if="driverInformation.rider_data.picture">
          <img
            :src="driverInformation.rider_data.picture"
            alt=""
            class="img-fluid"
          />
        </li>
        <!--        {{ driverInformation.rider_data }}-->
        <li v-if="driverInformation.rider_data.event !== 'created'">
          <h6>{{ _T('Driver Name') }}</h6>
          <h5 class="text-capitalize">
            {{ driverInformation.rider_data.rider_name || 'NA' }}
          </h5>
        </li>
        <li v-else>
          <h6>{{ _T('Driver information') }}</h6>
          <h5 class="text-capitalize">
            {{ _T('Driver information will update soon') }}
          </h5>
        </li>
        <!--<li>
          <h6>{{ _T('Driver License Plate') }}</h6>
          <h5>{{ driverInformation.rider_data.mobile_number }}</h5>
        </li>-->
        <li v-if="driverInformation.rider_data.mobile_number">
          <h6>{{ _T('Driver Mobile') }}</h6>
          <h5>{{ driverInformation.rider_data.mobile_number || 'NA' }}</h5>
        </li>
      </ul>
      <ul class="d-sm-none">
        <!--<li>
          <div class="media">
            <img
                src="/images/driver.png"
                alt=""
                class="img-fluid"
            />
            &lt;!&ndash;<div class="media-body">
              <span class="d-block">{{ driverInformation.rider_data.geom.latitude || 'NA' }}</span>
              <h5>Ahmad Deedat {{ driverInformation.rider_data.geom.longitude }}</h5>
            </div>&ndash;&gt;
          </div>
        </li>-->
        <li>
          <div class="d-flex">
            <img
              src="assets/svg/food-details/message.svg"
              alt=""
              class="msg-click"
            />
            <a href="#">
              <img src="assets/svg/food-details/phone-outline.svg" alt="" />
            </a>
          </div>
        </li>
      </ul>
    </div>
    <div v-else class="driver-info" :class="{ 'pt-0': !driverInformation }">
      <h5 class="mb-2">{{ _T('Order Information') }}</h5>
      <h4 class="order-success-msg">
        {{ _T('Order is placed successfully') }}
      </h4>
      <div v-if="selected_order">
        <p>Order# {{selected_order.order_no}} </p>
        <p
          v-if="selected_order.future_order_datetime"
          v-html="
            _T('Your order ll be delivered at ') +
              `${orderDate(selected_order.future_order_datetime)}`
          "
        ></p>
        <p
          v-else
          v-html="
            _T('Your order ll be delivered in ') +
              `${deliveryTime(find_store(this.$route.params.store_id))}`
          "
        ></p>
      </div>
      <div v-else>{{ _T('Loading') }}...</div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
// import Delivery from '@/mixins/Delivery'
import * as utils from '@/utils/main_utils'
export default {
  name: 'DriverInfo',
  // mixins: [Delivery],
  computed: {
    // https://developers.google.com/maps/documentation/geocoding/start?csw=1#ReverseGeocoding lat long to name & name to lat long
    ...mapState({
      order_status: state => state.tracking_store.order_status,
      driverInformation: state => state.tracking_store.driverInformation,
    }),
    ...mapGetters([
      '_T',
      'selected_order',
      'deliveryTime',
      'findTimezoneByStore',
      'make_slug_to_data',
      'find_store_by_main_id',
    ]),
  },
  methods: {
    find_store(store_id) {
      let store = this.make_slug_to_data('store', store_id)
      if (!store) return this.find_store_by_main_id(store_id)
      else return this.find_store_by_main_id(store._id)
    },
    orderDate(date) {
      if (date) {
        // let delivery_time = 0 //parseInt(this.deliveryTime(this.currentStore, true))
        // if (delivery_time >= 1440) {
        //   delivery_time = 60
        // }
        const storeTimezoneOffset = parseInt(
          this.findTimezoneByStore(this.currentStore).value
        )
        let convert_to_local = utils.convert_datetime(
          date,
          'DD MMMM YYYY,  hh:mm A',
          storeTimezoneOffset,
          true
        )
        // let merge_deliver_time = utils.convert_datetime(convert_to_local, 'DD MMMM YYYY,  hh:mm A', delivery_time, false)
        return convert_to_local
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.body-rtl {
  .driver-info.pt-0 {
    text-align: right;
  }
}
.driver-info {
  padding-top: calc(
    #{$px20} + (36 - 20) * ((100vw - #{$px320}) / (1920 - 320))
  );
  > h5 {
    margin-bottom: calc(
      #{$px12} + (26 - 12) * ((100vw - #{$px320}) / (1920 - 320))
    );
  }
  h5 {
    font-weight: 600;
  }
  ul {
    padding: 0;
    display: flex;
    align-items: center;
    border-bottom: none;
    li {
      h6 {
        margin-bottom: $px1;
      }
      + li {
        margin-left: calc(
          #{$px15} + (34 - 15) * ((100vw - #{$px320}) / (1920 - 320))
        );
        + li {
          margin-left: calc(
            #{$px30} + (54 - 30) * ((100vw - #{$px320}) / (1920 - 320))
          );
        }
      }
    }
  }
  .order-success-msg {
    color: $success-color;
    font-weight: 700;
    margin-bottom: 0;
  }
}
@media (max-width: 575px) {
  .driver-info {
    .driver-plate {
      display: none;
    }
    .d-sm-none {
      justify-content: space-between;
      li {
        .media {
          align-items: center;
          img {
            width: $px55;
          }
          .media-body {
            margin-left: $px15;
            span {
              font-weight: 600;
              font-size: $px13;
              line-height: $px17;
              letter-spacing: 0.5px;
              color: $light-font;
            }
            h5 {
              margin-bottom: 0;
            }
          }
        }
        .d-flex {
          a {
            margin-left: calc(
              #{$px15} + (24 - 15) * ((100vw - #{$px320}) / (1920 - 320))
            );
          }
        }
      }
    }
  }
}
</style>
